export type TabType = "episode" | "purchased" | "special" | "productInfo" | "preview" | "review";
type TabKey = "EPISODE" | "PURCHASED" | "SPECIAL" | "PRODUCT_INFO" | "PREVIEW" | "REVIEW";

/** 作品末端複数話の場合に表示する`TabTitle一覧` */
export const MULTI_SELECT_TABS: { [key in TabKey]: TabType } = {
  /** エピソード */
  EPISODE: "episode",
  /** 購入済み */
  PURCHASED: "purchased",
  /** 特典映像 */
  SPECIAL: "special",
  /** 作品情報 */
  PRODUCT_INFO: "productInfo",
  /** 予告編 */
  PREVIEW: "preview",
  /** レビュー */
  REVIEW: "review",
};

/** 作品末端舞台の場合に表示する`TabTitle一覧` */
export const STAGE_SELECT_TABS = {
  /** 配信情報 */
  DELIVERY: "delivery",
  /** 購入済み */
  PURCHASED: "purchased",
  /** 作品情報 */
  PRODUCT_INFO: "productInfo",
  /** レビュー */
  REVIEW: "review",
};

/** 作品末端グラビアの場合に表示する`TabTitle一覧` */
export const GRAVURE_SELECT_TABS = {
  /** パート */
  PART: "part",
  /** サンプル動画 */
  SAMPLE_VIDEO: "sampleVideo",
  /** 作品情報 */
  PRODUCT_INFO: "productInfo",
  /** レビュー */
  REVIEW: "review",
};

/** 作品末端スポット配信の場合に表示する`TabTitle一覧` */
export const SPOT_LIVE_SELECT_TABS = {
  /**
   * エピソード
   * - TODO : 初期リリース時点ではスコープアウトのためコメントアウト
   */
  // EPISODE: "episode",
  /** 作品情報 */
  PRODUCT_INFO: "productInfo",
};
